import axios from '@axios'

const route = 'register/employee'

export default {
  namespaced: true,
  state: {
    employees: [],
    addressDeleted: [],
    selectedServices: [],
    activeCommissionProduct: 'not',
    activeCommissionService: 'not',
    configCommissionService: {
      option_config: 'default',
      type: 'fixed',
      value_commission: '0.00',
      value_or_percentage: 'percentage',
    },
    configCommissionProduct: {
      option_config: 'default',
      type: 'fixed',
      value_commission: '0.00',
      value_or_percentage: 'percentage',
    },
    commission_personalized: [],
    commission_personalized_product: [],
    employee: {},
    address: [],
  },
  getters: {
    getAddress(state) {
      return state.address
    },
    getEmployees(state) {
      return state.employees
    },
    getAddressDeleted(state) {
      return state.addressDeleted
    },
    getSelectedServices(state) {
      return state.selectedServices
    },
    getConfigCommissionService(state) {
      return state.configCommissionService
    },
    getConfigCommissionProduct(state) {
      return state.configCommissionProduct
    },
    getActiveCommissionService(state) {
      return state.activeCommissionService
    },
    getActiveCommissionProduct(state) {
      return state.activeCommissionProduct
    },
    getCommissionPersonalized(state) {
      return state.commission_personalized
    },
    getCommissionPersonalizedProduct(state) {
      return state.commission_personalized_product
    },

    getEmployee(state) {
      return state.employee
    },
  },
  mutations: {
    setAddress(state, address) {
      state.address = address
    },
    setEmployees(state, employees) {
      state.employees = employees
    },
    setAddressDeleted(state, addressDeleted) {
      state.addressDeleted = addressDeleted
    },
    setSelectedServices(state, selectedServices) {
      state.selectedServices = selectedServices
    },
    setConfigCommissionService(state, configCommissionService) {
      state.configCommissionService = configCommissionService
    },
    setConfigCommissionProduct(state, configCommissionProduct) {
      state.configCommissionProduct = configCommissionProduct
    },
    setActiveCommissionService(state, activeCommissionService) {
      state.activeCommissionService = activeCommissionService
    },
    setActiveCommissionProduct(state, activeCommissionProduct) {
      state.activeCommissionProduct = activeCommissionProduct
    },
    setCommissionPersonalized(state, commissionPersonalized) {
      state.commission_personalized = commissionPersonalized
    },
    setCommissionPersonalizedProduct(state, commissionPersonalized) {
      state.commission_personalized_product = commissionPersonalized
    },
    setEmployee(state, employee) {
      state.employee = employee
    },
  },
  actions: {
    getAll(context, {
      itemsPerPage, page, search, ...filters
    }) {
      return axios.post(`${route}?page=${page}&items_per_page=${itemsPerPage}&search=${search}`, filters)
    },

    store(context, employee) {
      return axios.post(`${route}/store`, employee)
    },

    update(context, employee) {
      return axios.put(`${route}/update/${employee.id}`, employee)
    },

    destroy(context, employee) {
      return axios.delete(`${route}/${employee.id}`)
    },

    getStates() {
      return axios.get('helper/states')
    },

    getCities(context, state_id) {
      return axios.get(`helper/cities/${state_id}`)
    },

    getRoles() {
      return axios.get('helper/get_roles')
    },

    // EDITAR AVATAR
    uploadImage(context, image) {
      const formData = new FormData()
      formData.append('img', image.img)

      return axios.post(`${route}/avatar/${image.employee_id}`, formData)
    },

    loadAvatar(context, employee_id) {
      return axios.get(`${route}/load_avatar/${employee_id}`)
    },
    removeImage(context, data) {
      return axios.delete(`${route}/remove_avatar/${data.employee_id}`)
    },

    // carregar serviços
    getServices(context) {
      return axios.get('helper/get_services')
    },

    // carregar serviços associado ao funcionario
    getEmployeeServices(context, employee_id) {
      return axios.get(`${route}/get_services/${employee_id}`)
    },

    // //CADASTRAR ENDEREÇO
    // saveAddress(context, address) {
    //   console.log(address, 'sdas')
    //   return axios.post(route + '/address', address)
    // },
    /**
     * exportar lista de funcionarios
     */
    exportExcel(context, filters) {
      return axios.post(`${route}/export_excel`, filters, { responseType: 'blob' })
    },

    /**
     * carrega os serviços com as commissoes diponiveis
     */
    getServicesWithCommissions(context, employee_id) {
      return axios.get(`${route}/get_services_with_commissions/${employee_id}`)
    },

    /**
     * carrega os produtos com as commissoes diponiveis
     */
    getProductsWithCommissions(context, employee_id) {
      return axios.get(`${route}/get_products_with_commissions/${employee_id}`)
    },

    // criar login e senha para o funcionario
    createLogin(context, login) {
      return axios.post(`${route}/create_login`, login)
    },

    // remover login e senha do funcionario
    removeLogin(context, employee_id) {
      return axios.post(`${route}/remove_login/${employee_id}`)
    },

    /**
     * atualiza perfil de acesso do funcionario
     */
    updateRole(context, payload) {
      return axios.post(`${route}/update_role`, payload)
    },
  },
}
